<template>
  <div class="messagecenter">
    <div class="messagecenter-headline">
      <p class="headline-name">
        <!-- <a-icon type="sound" indeterminate="false" style="margin-right:10px" /> -->
        <img class="messageico" src="../../assets/imgs/xiaoxi.png" />
        {{$t('translateText.MessageCenter.NewMessage.MessageCenter')}}
      </p>
    </div>
    <div class="newmessage-content">
      <p class="messageheaders">  {{$t('translateText.MessageCenter.NewMessage.MessageTitle')}}</p>
      <p class="messageheaders"><a-input :placeholder="$t('translateText.MessageCenter.NewMessage.EnterMessageTitle')" v-model="messagename" style="letter-spacing: 1px;"/></p>
      <div class="releaseobject">
        <p class="releaseobject-headline">
          <span>{{$t('translateText.MessageCenter.NewMessage.PublishTo')}}</span>
          <!-- <a-input-search
            placeholder="搜索"
            style="width: 50%; height: 60%; margin-right: 4%"
            @search="onSearch"
          /> -->
          <search @search="onSearch" />
        </p>
        <a-radio-group name="radioGroup" :defaultValue=0 >
          <a-radio  v-if="isshow"  :value="0" @click="sendrole(0)"> {{$t('translateText.MessageCenter.NewMessage.AllStaff')}} </a-radio>
          <a-radio  v-if="isshow" :value="1" @click="sendrole(3)"> {{$t('translateText.MessageCenter.NewMessage.Teacher')}} </a-radio>
          <a-radio  v-if="isshow"  :value="2" @click="sendrole(4)"> {{$t('translateText.MessageCenter.NewMessage.Student')}} </a-radio>
          <a-radio  v-if="!isshow"  :value="3" @click="sendrole(0)"> {{$t('translateText.MessageCenter.NewMessage.IsAllStaff')}} </a-radio>
          <a-radio  v-if="!isshow"  :value="4" @click="sendrole(3)"> {{$t('translateText.MessageCenter.NewMessage.IsTeacher')}} </a-radio>
          <a-radio  v-if="!isshow"  :value="5" @click="sendrole(4)"> {{$t('translateText.MessageCenter.NewMessage.IsStudent')}} </a-radio>
        </a-radio-group>
        <a-select  @change="handleChange" v-model="defaultdata" >
          <a-select-option @click="switchover" v-for="classinfo in classarr" :key="classinfo.key">
            {{ classinfo.name }}
          </a-select-option>
        </a-select>
        <err-table
          @usercheckAll="usercheckAll"
          :columns="columns" 
          :data2="data" 
          :Show="true"
        >
        </err-table>
      </div>
      <div class="message-content">
        <p class="releaseobject-headline">
          <span>{{$t('translateText.MessageCenter.NewMessage.MessageContent')}}</span>
        </p>
        <!-- <input type="text" style="width:100%;height:90%;border:0;utline: none;"> -->
        <textarea
          style="
            width: 100%;
            height: 80%;
            border: 0;
            outline: none;
            resize: none;
            line-height: 24px;
            letter-spacing: 2px;
            padding:15px;
          "
          v-model="messagecontent"
        ></textarea>
      </div>
      <div class="newmessage-but">
        <one-button  @click="cancel">{{$t('translateText.MessageCenter.NewMessage.Cancel')}}</one-button>
        <one-button @click="circularize">{{$t('translateText.MessageCenter.NewMessage.Confirm')}}</one-button>
      </div>
    </div>
  </div>
</template>
<script>
import errTable from "../../components/Table/Table";
import search from "../../components/search";
import {NewMessage,getAllUserByRoleId,getAllClass} from "@/utils/api"
export default {
  data() {
    return {
      realName:"",
      isshow:true,
      defaultdata:this.$t('translateText.MessageCenter.NewMessage.All'),
      classarr:[],
      selectedRowKeys:[],
      userinfo:{},
      messagename:"",
      messagecontent:"",
      roleid:0,
      columns:[
        {
          title: this.$t('translateText.MessageCenter.NewMessage.Name'),
          dataIndex: "name",
        },
        {
          title: this.$t('translateText.MessageCenter.NewMessage.Identity'),
          dataIndex: "identity",
        }
      ],
      data:[],
      userids:[{ iUserId:1}],
      // checked: false,
      // checkedNames: [],
      // checkedArr: ["0", "1", "2", "3", "4", "5"],
      // num:this.checkedArr.length,

    };
  },
  methods: {
    //完成下拉框与单选框的互斥
    switchover(){
      if(this.defaultdata ==  this.$t('translateText.MessageCenter.NewMessage.All')){
        this.isshow = !this.isshow
      }
    },
    //查询某班级全部人员
    handleChange(){
    this.roleid = 4
    this.inquireuser()
    },

    //全选
    usercheckAll(val) {
      
            this.selectedRowKeys = val;
        },
    sendrole(num) {
      
      this.defaultdata = this.$t('translateText.MessageCenter.NewMessage.All')
      this.roleid = num
      this.data = []
      this.inquireuser()
    },
    onSearch(value) {
      this.realName=value
      this.inquireuser()
    },
    changeAllChecked: function () {
      if (this.checked) {
        this.checkedNames = this.checkedArr;
      } else {
        this.checkedNames = [];
      }
    },
    cancel(){
      this.$router.go(-1);
    },
    circularize(){//发放通知
      // var currentCity=localStorage.getItem("userinfo");
      this.userinfo = this.$store.state.userinfo
      let arr2 = this.selectedRowKeys.map((item) => {
                return Object.assign({}, { iUserId: item.id})
      })
       arr2.push({ iUserId: this.userinfo.iUserId})
      if (this.messagename.length<=0 ||  this.messagename.split(" ").join("").length ==0) {
        this.$message.error(this.$t('translateText.MessageCenter.NewMessage.EnterTitle'))
      }else
      if (this.messagecontent.length<=0 ||  this.messagecontent.split(" ").join("").length ==0) {
        this.$message.error(this.$t('translateText.MessageCenter.NewMessage.EnteContent'))
      }else if (arr2.length<=0) {
        this.$message.error(this.$t('translateText.MessageCenter.NewMessage.SelectPublishingObject'))
      }else{
        NewMessage({
          iSendUserId:this.userinfo.iUserId,
          iCourseId:0,
          strMessageName:this.messagename,
          strMessageContent:this.messagecontent,
          listUser:arr2,   
        }).then((response)=>{
          this.$EventBus.$emit('messageinfo')
          if(response.data.iCode == 0){
            //这里添加一条消息数据，放入vuex中的message数组中
            //构造一条消息数据obj，满足渲染的结构
            // let obj = {}
            // this.$store.commit("messagePushItem",obj)
            this.$router.push('/newsCenter')
            this.$EventBus.$emit("newmessage")
          }else{
            return this.$message.error(response.data.strMessage);
          }
        })
      }
    },
    inquireuser(){
      getAllUserByRoleId({
        iRoleId:this.roleid,
        strUserName:"",
        strRealName:this.realName,
        iUserState:1,
        iClassId:this.defaultdata ==this.$t('translateText.MessageCenter.NewMessage.All') ? "0":this.defaultdata,
      }).then((response)=>{
        if(response.data.iCode == 0){
           this.userinfo = this.$store.state.userinfo;
          this.data = []
          for (let i=0;i<response.data.objData.length;i++){
            var user = {
              id:"",
              key:"",
              name:"",
              identity:"",
            }
            user.id = response.data.objData[i].iUserId
            user.key = response.data.objData[i].iUserId
            user.name = response.data.objData[i].strRealName,
            user.identity = response.data.objData[i].role.strRoleName
            if(this.userinfo.iUserId!==user.id){
              this.data.push(user)
            }
          }
        }else{
          return this.$message.error(response.data.strMessage);
        }
      })
    }
  },
  watch: {
    checkedNames: function () {
      if (this.checkedNames.length == this.checkedArr.length) {
        this.checked = true;
      } else {
        this.checked = false;
      }
    },
  },
   components: {
    search,
    errTable,
  },
  mounted(){
    this.inquireuser()
    getAllClass({}).then((response) => {
      if (response.data.iCode == 0) {
        this.classarr = response.data.objData.map((item) => {
        return Object.assign({}, { name:item.strClassName,key:item.iClassId });
        
        });
      } else {
        return this.$message.error(response.data.strMessage);
      }
    });
},
};
</script>
<style lang="stylus" scoped>
/deep/.ant-select-selection--single
  height 25px
.messagecenter {
  width: 100%;
  height: 100%;
  background-color: white;
}

.messagecenter-headline {
  width: 100%;
  height: 10%;

  @media (max-width: 1025px) {
    height: 12%;
  }

  @media (max-width: 500px) {
    height: 15%;
  }
}

.messageico {
  height: 25%;
  margin-right: 10px;
}

.headline-name {
  width: 90%;
  height: 90%;
  margin-left: 2%;
  font-size: 15px;
  letter-spacing: 2px;
  font-weight: 700;
  display: -webkit-flex;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 2px solid #dadada;
}

.newmessage-content {
  width: 100%;
  height: 85%;
  // background-color pink
}

.messageheaders {
  width: 90%;
  margin-top: 1%;
  margin-left: 2%;
  text-align: left;
  font-size: 15px;
  letter-spacing: 1px;
  font-width: 700;

  & input {
    width: 100%;
    border-color: #dadada;
  }
}

.releaseobject {
  width: 35%;
  height: 70%;
  float: left;
  overflow auto
  // background-color: pink;
  margin-top: 1%;
  margin-left: 2%;
  border: 1px #dadada solid;
  overflow: auto;
}

.message-content {
  width: 53%;
  height: 70%;
  overflow auto
  float: left;
  border: 1px #dadada solid;
  margin-top: 1%;
  margin-left: 2%;
  float: left;
}

.releaseobject-headline {
  width: 100%;
  height: 10%;
  background-color: #F4F4F4;
  font-size: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  & span {
    color: #2FAEB6;
    margin-left: 4%;
  }
}
.search
  width 60%
/deep/.ant-select
  width 30%
  height 32px
/deep/.ant-input {
  height: 100%;
  // border-radius: 20px;
}

.releaseobject-headline {
  background-color: #F4F4F4;
}

/deep/.ant-radio-group {
  width 60%
  display: flex;
  justify-content: space-around;
  align-items: center;
  float left
}

.personnel {
  width: 100%;
  height: 10%;
  display: flex;
  align-items: center;

  & li {
    width: 15%;
    float: left;
    margin-right: 17%;
  }
}

.checkbox-input {
  width: 16px;
  height: 16px;
}

.newmessage-but 
  width: 100%;
  height: 20%;
  float: left;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  & button 
    margin-left: 25%;
  

</style>